<template>
  <div
    class="d-flex flex-row align-items-center justify-content-center bg-light py-3"
  >
    <button
      class="btn bg-gradient-success rounded-pill mb-0 me-2"
      @click="showModal('aprobar')"
      v-if="this.estatus == 'PENDIENTE'"
    >
      <i class="ri-check-line"></i>
      Aprobar
    </button>
    <button
      class="btn bg-gradient-danger mb-0 rounded-pill me-2"
      @click="showModal('rechazar')"
      v-if="this.estatus == 'PENDIENTE'"
    >
      <i class="ri-close-line"></i>
      Rechazar
    </button>
    <a
      :href="urlCotizacionPreview($route.params.token)"
      class="btn bg-gradient-secondary mb-0 rounded-pill"
    >
      <i class="ri-download-line"></i>
      Descargar
    </a>
  </div>
</template>

<script>
import useStoreCotizaciones from "@/store/cotizaciones";
import { onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import usePublicStore from "@/store/public";
export default {
  props: {
    estatus: {
      type: String,
      required: true,
    },
  },
  setup() {
    usePublicStore;
    const { showModal } = usePublicStore();
    const { urlCotizacionPreview } = useStoreCotizaciones();
    const { plazo12, plazo24, plazo36, plazo48, plazo60 } = storeToRefs(
      useStoreCotizaciones()
    );

    onUnmounted(() => {
      plazo12.value = "12";
      plazo24.value = "24";
      plazo36.value = "36";
      plazo48.value = "48";
      plazo60.value = "00";
    });

    return {
      urlCotizacionPreview,
      showModal,
    };
  },
};
</script>

<style></style>
